import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "../Button";

const checkIsIOS = () => {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
};

function preventOrphan(text) {
  if (!text) return "";
  const words = text.trim().split(" ");
  if (words.length < 2) return text;
  return [...words.slice(0, -2), words.slice(-2).join("\u00A0")].join(" ");
}

const MissionSection = () => {
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const checkIOS = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };
    setIsIOS(checkIOS());
  }, []);

  const headline = "Made in America*";
  const paragraph = "We're revolutionizing cleaning with powerful, sustainable solutions made right here in the USA*. Our American-made* products deliver exceptional results while supporting local jobs and communities. No tariffs, no compromises - just pure American cleaning power.";
  const [isIOSDevice, setIsIOSDevice] = useState(false);

  useEffect(() => {
    setIsIOSDevice(checkIsIOS());
  }, []);

  return (
    <section className="py-12 md:py-16 px-6 md:px-12 lg:px-24">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center justify-items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="flex justify-center items-center w-full"
          >
            <div className="relative w-full max-w-md flex justify-center">
              {isIOSDevice ? (
                <img
                  src="https://images.ctfassets.net/hdznx4p7ef81/vgdFbFIQRGKdDk5Sjmj0A/4c72a02b6a85912292e645097b27055c/Gen-4_Flag-image.png"
                  alt="Made in America"
                  className="w-64 h-auto md:w-96 lg:w-[500px] object-contain scale-150 md:scale-1175 lg:scale-200 -rotate-[0deg]"
                  style={{ mixBlendMode: 'normal' }}
                />
              ) : (
                <video
                  src="https://videos.ctfassets.net/hdznx4p7ef81/7FAYaB8msFZnVuKOMhuFse/30b2c632640ff0043ceea78211521787/Gen-4_Flag8.webm"
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-64 h-auto md:w-96 lg:w-[500px] object-contain scale-150 md:scale-1175 lg:scale-200 -rotate-[0deg]"
                />
              )}
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="space-y-6 flex flex-col items-center text-center max-w-2xl"
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#D3242A] uppercase" style={{ fontFamily: "Geogrotesque, sans-serif" }}>
              {preventOrphan(headline)}
            </h2>
            <p className="text-lg text-gray-700">
              {preventOrphan(paragraph)}
            </p>
            <Link to="/products" className="flex justify-center">
              <Button
                variant="primary"
                size="large"
                className="mt-8"
              >
                Explore Our Products
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection; 